export const UPDATE_CURRENT_RENDERED_TREE = "UPDATE_CURRENT_RENDERED_TREE";
export const SET_MINIMIZE_WINDOW = "SET_MINIMIZE_WINDOW";


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window/src/actions/actionTypes.ts